import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTipoProduto = () => {
  const [tipoProduto, setTipoProduto] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchTipoProduto = async () => {
      try {
        const response = await httpClient.get(
          `/api/denominacaogenerica/tipoproduto`,
        );

        const options = response.data.map(
          (tipoProduto: { value: number; label: string }) => ({
            value: tipoProduto.value.toString(),
            label: tipoProduto.label,
          }),
        );
        setTipoProduto(options);
      } catch (error) {
        console.error('Erro ao buscar Tipo Produto', error);
      }
    };

    fetchTipoProduto();
  }, []);

  return tipoProduto;
};
